import clsx from "clsx";
import { useLazyImg } from "../helpers/useLazyImg";
import s from "./LazyImg.module.scss";

interface Props {
  imgUrl: string | undefined;
  fallbackImgURL?: string;
  alt: string;
  reserveImgUrl?: string | undefined;
}

export const LazyImg = ({
  imgUrl,
  fallbackImgURL,
  alt,
  reserveImgUrl,
}: Props): JSX.Element => {
  const { imgLoading, handleLoad, handleError, currentImgURL, imgRef } =
    useLazyImg(imgUrl, fallbackImgURL, reserveImgUrl);

  return (
    <div className={s.wrapper}>
      <img
        ref={imgRef}
        className={clsx(!imgLoading && s.loaded)}
        src={currentImgURL}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
      />

      {imgLoading && (
        <div className={s.img_skeleton}>
          <div className="skeleton" />
        </div>
      )}
    </div>
  );
};
